export default __webpack_public_path__ + "static/media/tabs.ff480642.svg";